import { Html } from '@react-three/drei';

function ProductClearanceLabel({
  value,
  reverseConfig,
  textSize,
  color = 'green',
  focus = false,
}) {
  const labelStyle = () => ({
    color: value >= 0 ? color : 'red',
    fontSize: `${textSize}px`,
    background: focus ? 'rgb(255, 255, 255)' : 'rgba(255, 255, 255, 0.7)',
    padding: `${Math.ceil(textSize / 4)}px ${Math.round(textSize / 2)}px`,
    borderRadius: '2px',
    fontWeight: focus ? 'bold' : 'normal',
  });

  return (
    <Html
      sprite
      distanceFactor={15}
      rotation={reverseConfig === 1 ? [0, Math.PI, 0] : [0, 0, 0]}
    >
      <div style={labelStyle()}>{Math.round(value)}</div>
    </Html>
  );
}

export default ProductClearanceLabel;
